exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2-Iwt-aDQppTVVKGaylGZm {\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  position: absolute;\n}\n\n.FDpiRO-7K8DydTDctmSt- {\n  width: 75px;\n  top: 62px;\n  right: 30px;\n}\n\n.MyWKXaxrQ8X0MwyTOmdzW {\n  width: 75px;\n  top: 85px;\n  -webkit-transform: translate(137.5px, -20px);\n          transform: translate(137.5px, -20px);\n}\n\n._1HNQQOZmO832Qvl-BOKbn7 {\n  width: 75px;\n  top: 15px;\n  left: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"modelLogo": "_2-Iwt-aDQppTVVKGaylGZm",
	"bb-ourocard-black": "FDpiRO-7K8DydTDctmSt- _2-Iwt-aDQppTVVKGaylGZm",
	"bradesco-prime-black": "MyWKXaxrQ8X0MwyTOmdzW _2-Iwt-aDQppTVVKGaylGZm",
	"itau-normal-black": "_1HNQQOZmO832Qvl-BOKbn7 _2-Iwt-aDQppTVVKGaylGZm"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"importLoaders":1,"modules":true}!../node_modules/postcss-loader/lib?{"ident":"postcss"}!../node_modules/postcss-loader/lib?{"plugins":[null]}!./components/ModelLogo/style.css
// module id = 35
// module chunks = 0